import config from 'src/config';
import { EmploymentTypeEnum } from 'src/shared/enums/employmentType.enum';
import { getUnionClassifications, translationExists } from 'src/utils';

export function parseTimestampFromDB(dateString: string): number | null {
  // Data from BE is in MM/DD/YYYY format
  const parts = dateString.split('/');
  if (parts.length !== 3) {
    console.error('Invalid date format. Expected MM/DD/YYYY:', dateString);
    return null;
  }

  const month = parseInt(parts[0], 10) - 1;
  const day = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);
  const date = new Date(year, month, day);

  if (isNaN(date.getTime())) {
    console.error('Invalid date:', dateString);
    return null;
  }

  return date.getTime() / 1000;
}

export const getUnionClassificationOptions = (employmentType: EmploymentTypeEnum, localUnion: string | null, t: (key: string) => string) => {
  if (employmentType === EmploymentTypeEnum.NON_UNION) {
    const nonUnionClassifications = config?.options?.GENERIC_CLASSIFICATIONS || [];

    return nonUnionClassifications.map((classification: string) => ({
      key: classification,
      value: t(`union_classifications.GENERIC.${classification}`),
    }));
  }

  return getUnionClassifications(localUnion, '').map((classification: string) => {
    const keyToCheck = `union_classifications.${localUnion}.${classification}`;
    const translationKey = translationExists(keyToCheck) ? keyToCheck : `union_classifications.GENERIC.${classification}`;

    return { key: classification, value: t(translationKey) };
  });
};

export function timestampToDBFormat(timestamp: number | null) {
  if (timestamp === null) {
    return null;
  }
  const date = new Date(timestamp * 1000);
  if (isNaN(date.getTime())) {
    return null;
  }
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return { day, year, month };
}
